module.exports = __webpack_public_path__ + "static/p16-ca7d3377e983013873d6588ed9e8b470.jpg";